export const GET_ALL_EVENT = 'GET_ALL_EVENT'
export const GET_ALL_EVENT_SUCCESS = 'GET_ALL_EVENT_SUCCESS'
export const GET_ALL_EVENT_FAIL = 'GET_ALL_EVENT_FAIL'

export const SET_EVENT_LOADING = 'SET_EVENT_LOADING'
export const TOTAL_PAGE = 'TOTAL_PAGE'
export const API_ERROR = 'API_ERROR'
export const ADD_ALL_PREVIEW = 'ADD_ALL_PREVIEW'
export const ADD_VALIDATION = 'ADD_VALIDATION'
